const FacebookContent = () => {
	let CT = window.Texts.facebook;
	if (Config.mode == 'liveest')
		return null;
	return (
		<div className="facebook-contant">
			<div className="prow same-boxes">
				<div className="pcol span-2">
					<div className="inner">
						<div className="fb-page fb_iframe_widget" data-href="https://www.facebook.com/nabytekIDEA/?fref=ts"
							data-small-header="false"
							data-adapt-container-width="true"
							data-hide-cover="false"
							data-show-facepile="true"
							data-width="500"
							fb-xfbml-state="rendered"
							fb-iframe-plugin-query="adapt_container_width=true&amp;app_id=&amp;container_width=458&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2FnabytekIDEA%2F%3Ffref%3Dts&amp;locale=en_US&amp;sdk=joey&amp;show_facepile=true&amp;small_header=false&amp;width=500">
							<span style={{ verticalAlign: 'bottom', width: '458px', height: '180px' }}><iframe name="f2aed9a062cdf8" width="500px" height="1000px" title="fb:page Facebook Social Plugin" frameBorder="0" allowtransparency="true" allowFullScreen="true" scrolling="no" allow="encrypted-media" src="https://www.facebook.com/v2.5/plugins/page.php?adapt_container_width=true&amp;app_id=&amp;channel=https%3A%2F%2Fstaticxx.facebook.com%2Fconnect%2Fxd_arbiter.php%3Fversion%3D44%23cb%3Dfd05d25c48d978%26domain%3Dwww.idea-nabytek.cz%26origin%3Dhttps%253A%252F%252Fwww.idea-nabytek.cz%252Ff181e5e58fa3514%26relation%3Dparent.parent&amp;container_width=458&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2FnabytekIDEA%2F%3Ffref%3Dts&amp;locale=en_US&amp;sdk=joey&amp;show_facepile=true&amp;small_header=false&amp;width=500" style={{ border: 'none', visibility: 'visible', width: '458px', height: '180px' }} /></span></div>
					</div>
				</div>
				<div className="pcol span-1 contact-col">
					<div className="inner">
						<div className="content">
							<h2 dangerouslySetInnerHTML={{ __html: CT.question}}></h2>
							<ul>
								<li className="tel">{CT.phone}</li>
								<li className="open">{CT.openhours}</li>
							</ul>
							<a className="main-link" href="#"><span><u>{CT.allContacts}</u></span></a>
						</div>
					</div>
				</div>
			</div>
		</div>);
}
export default FacebookContent;


var element = document.getElementById("app-facebook");
if (element) {
	ReactDOM.render(<FacebookContent />, element);
}